import {
	DOWNLOAD_CUSTOMER_EMAIL,
	GET_SHOPIFY_APP_CONNECTION,
	ERROR_DOWNLOAD_CUSTOMER_EMAIL,
	ERROR_GET_SHOPIFY_APP_CONNECTION
} from '../../../constants';

const shopifyState = {
	meta: null,
	customerEmails: null,
	count: 0,
	phase: 'loading',
	appConnection: null
};

export default function dashboardEmailsReducer(state = shopifyState, action) {
	switch (action.type) {
		case DOWNLOAD_CUSTOMER_EMAIL:
			return Object.assign({}, state, {
				customerEmails: action.customer_emails,
				count: action.count,
				meta: action.meta,
				phase: 'loaded'
			});

		case GET_SHOPIFY_APP_CONNECTION:
			return Object.assign({}, state, {
				meta: action.meta,
				appConnection: action.app_connection
			});
		case ERROR_DOWNLOAD_CUSTOMER_EMAIL:
		case ERROR_GET_SHOPIFY_APP_CONNECTION:
			return Object.assign({}, state, {
				meta: action.meta
			});

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-page/reducers/index.js